import WorkerStatusBar from "../Common/WorkerStatusBar";
import {colors} from "../UIElements/Elements";
import TableCategoriesListView from "../TableCategoriesListView";
import TableListView from "../TableListView";
import {useState} from "react";

const WorkerTableView = () => {
    const list = [
        {id: "1", name: "Terasa", active: true},
        {id: "2", name: "Lokali", active: false},
        {id: "3", name: "Bar", active: false},
        {id: "4", name: "Restaurant", active: false},
        {id: "5", name: "Lobby", active: false},
        {id: "6", name: "Bar", active: false},
        {id: "7", name: "Restaurant", active: false},
        {id: "8", name: "Lobby", active: false}
    ];

    const tableList = [
        {name: "11", categoryId: "1", status: "FREE", foodStatus:true},
        {name: "12", categoryId: "1", status: "BUSY", foodStatus:false},
        {name: "13", categoryId: "1", status: "FREE", foodStatus:false},
        {name: "14", categoryId: "1", status: "BUSY", foodStatus:true},
        {name: "15", categoryId: "1", status: "FREE", foodStatus:true},
        {name: "16", categoryId: "1", status: "FREE", foodStatus:true},
        {name: "17", categoryId: "1", status: "BUSY", foodStatus:false},
        {name: "18", categoryId: "1", status: "FREE", foodStatus:false},
        {name: "19", categoryId: "1", status: "BUSY", foodStatus:true},
        {name: "10", categoryId: "1", status: "FREE", foodStatus:true},
        {name: "21", categoryId: "2", status: "BUSY", foodStatus:false},
        {name: "22", categoryId: "2", status: "FREE", foodStatus:true},
        {name: "23", categoryId: "2", status: "BUSY", foodStatus:false},
        {name: "24", categoryId: "2", status: "FREE", foodStatus:true},
        {name: "25", categoryId: "2", status: "BUSY", foodStatus:true},
        {name: "31", categoryId: "3", status: "FREE", foodStatus:false},
        {name: "32", categoryId: "3", status: "BUSY", foodStatus:true},
        {name: "33", categoryId: "3", status: "FREE", foodStatus:true},
        {name: "34", categoryId: "3", status: "BUSY", foodStatus:true},
        {name: "35", categoryId: "3", status: "FREE", foodStatus:true}
    ];

    const [activeCategoryId, setActiveCategoryId] = useState(list.length > 0 ? list[0].id : null);
    return (
        <div
            className="w-screen h-screen flex flex-col items-center justify-center text-white overflow-auto flex-wrap relative bg-center">
            <WorkerStatusBar workerName={"Dardan"} outletName={"Garden"}/>
            <div className={`fixed top-[8vh] left-0 h-[92vh] text-black w-[100vw] ${colors.light}`}>
                <TableCategoriesListView list={list} setActiveCategoryId={setActiveCategoryId} activeCategoryId={activeCategoryId}/>
                <TableListView list={tableList} setActiveCategoryId={activeCategoryId}/>
            </div>
        </div>
    );
};

export default WorkerTableView;
